//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "qualityOrderDetailMore",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toAll(){
      this.$router.push({name:'qualityOrderDetailAll'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/detailMore.vue